export default {
  FONT: {
    HEADLINE: {
      LEARGE: '24px',
      SMALL: '18px',
      SMALLER: '13px',
      MEDIUM: '16px',
      XL: '22px',
    },
    SUB_HEADLINE: {
      LEARGE: '16px',
      SMALL: '14px',
    },
    FOOTER: '13px',
    REGULAR: '13px',
    LINK: '13px',
    SMALL: '10px',
    BIG: '16px',
    BIGGER: '18px',
    BUTTON: '16px',
    BUTTON_SMALL: '13px',
    INPUT_LABEL: '14px',
    MSG: '16px',
    WEIGHT: 500,
    LG: '20px',
    NORMAL: '14px',
    MEDIUM: '15px',
    ITEM_NAME: '25px',
  },
  MODAL: {
    WIDTH: '860px',
    HEIGHT: '650px',
  },
  ICON: {
    WIDTH: '80px',
    HEIGHT: '80px',
  },
  PADDING: {
    APP: '40px',
    APP_SMALLER: '20px',
  },
}
